
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Sqmi", function(module, exports) {
/* ShortcutsDragContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");





var $1DWH0 = parcelRequire("1DWH0");

const $a8b3b36815423b52$export$8a2496cd6c012f98 = (0, $1DWH0.default)()(class OperationalEvent extends (0, $42omo.Component) {
    componentDidMount() {
        this.sendOperationalEvent();
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.id !== this.props.id || nextProps.action !== this.props.action || nextProps.actionSubject !== this.props.actionSubject;
    }
    componentDidUpdate() {
        this.sendOperationalEvent();
    }
    sendOperationalEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent, action: action, actionSubject: actionSubject, source: source, attributes: attributes, containerType: containerType, containerId: containerId } = this.props;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                source: source,
                containerType: containerType,
                containerId: containerId,
                attributes: attributes || null
            }
        }).fire();
    }
    render() {
        return null;
    }
});



var $7aRa9 = parcelRequire("7aRa9");


var $1NBp8 = parcelRequire("1NBp8");


var $luv00 = parcelRequire("luv00");

/* DraggableShortcutsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/self-closing-comp */ 






var $aXWIB = parcelRequire("aXWIB");


var $dRnqM = parcelRequire("dRnqM");


var $jTxSS = parcelRequire("jTxSS");


var $5TXU5 = parcelRequire("5TXU5");

var $hpUsb = parcelRequire("hpUsb");

var $5znEc = parcelRequire("5znEc");


var $9CM6e = parcelRequire("9CM6e");


var $lGgRw = parcelRequire("lGgRw");


var $4kfV4 = parcelRequire("4kfV4");


var $4T4vf = parcelRequire("4T4vf");


var $bSjaC = parcelRequire("bSjaC");


var $7XdU2 = parcelRequire("7XdU2");


var $4AppU = parcelRequire("4AppU");


var $afUmf = parcelRequire("afUmf");


var $882hS = parcelRequire("882hS");


var $2WHHL = parcelRequire("2WHHL");


var $2n8po = parcelRequire("2n8po");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $jmjWc = parcelRequire("jmjWc");


var $dPJCf = parcelRequire("dPJCf");





var $56QzY = parcelRequire("56QzY");


var $6mKj3 = parcelRequire("6mKj3");


var $1AV5C = parcelRequire("1AV5C");


var $9wGTI = parcelRequire("9wGTI");


var $h4oCC = parcelRequire("h4oCC");


const $8bcdd2b9838a59f9$var$LinkPickerWithPlugin = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Etfos",
    name: "LinkPickerWithPlugin",
    loader: async ()=>(await (parcelRequire("32LtO"))).LinkPickerWithPlugin
});
const $8bcdd2b9838a59f9$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.__SSR_RENDERED__;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bcdd2b9838a59f9$var$DragPreview = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4lere _2rkofajl _11q7hp5a _1pxwftgi _1e0c1txw _4cvr1h6o _vchhusvi _1bsbdlvw _1bah1yb4 _syazazsu _43dsd34b _1cvzglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Legacy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { draggableState: draggableState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko1l7b _80om73ad _kqswh2mm _c71l1ylp _1bfhidpf _ncow1dpa _t6db1j28 _1uyw1dpa _7k461aqn _5hvf1rpy _1kzckb7n _n5sikb7n _1j6mf1ug _9vpt1osq _1vjv1txw _1dsjidpf _hpfx19bv _1pi6idpf _1rqg19bv _j8ve1gyu _d8gsu2gc _1m7d1ylp _nfqw1h6o _mig07vkz _rqui7vkz _1mfy7vkz _1tlu7vkz _1uzz7vkz _1nao7vkz _1knu7vkz _1m537vkz _18387vkz _5fr87vkz _1x8p7vkz _3uc87vkz _dgj27vkz _f2tv7vkz _ors87vkz _19q77vkz _drvf7vkz _dz5k7vkz _1xdi7vkz _1mjq7vkz _1ozr7vkz _p4o77vkz _b4047vkz _1hlo7vkz _1f4k7vkz _1c2c7vkz _6ghj7vkz _wc727vkz _ppk67vkz _12it7vkz _1p521txw _1n2o1txw _1v241txw _1o8v1txw _t8q21txw _y3u81h6o _3zzm1h6o _aird1h6o _rcsr1h6o _19fb1h6o _1wjbi7uo _109o1ylp _1c877vkz _1so97vkz _1s5b7vkz _1uhy7vkz _1bti7vkz _10zm7vkz _16nc7vkz _1ilt7vkz _1t827vkz _rcgi7vkz _uyp97vkz _cbv57vkz _142w7vkz _1fe57vkz _1cld7vkz _3h3j7vkz _1emvnkob _1lbdnkob _az5onkob _w68onkob _109o14no _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43dsazsu _p03cazsu _oavvazsu _oxk4azsu _1cayazsu _13uifcek _j0cz1osq _jdednpx7 _15kb6x5g _13ozidpf _1nypidpf _yuv7idpf _hrieidpf _13wbidpf _aliv1tcg _p1061tcg _13i61tcg _1cayd34b _irr31dpa",
            __cmplp.draggableState === 'dragging' ? "_tzy41ck0" : "_tzy4kb7n",
            __cmplp.draggableState === 'idle' ? "_jomr1dpa _10j71dpa _irr31dpa" : "_jomr1wug _10j71wug _irr31wug",
            __cmplp.draggableState === 'idle' ? "_1y9g1kr1 _1rhokb7n" : "_1rhoidpf",
            !$8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() && "_cs4c15vq _lgpm15vq _jt20idpf _1vm1or1b _1xsaidpf _1l4e1crf _1p7a1r31 _hg20glyw _1lv6nqa1 _nn7ofhey _19y2178v _t41dlb4i _11r2b3bt _hy7n1o8l _i2xg14yf _1som14yf _wvd5h2mm _1jz6i2wt _avkbidpf _1h687vkz _1086glyw _19i6f0ml _fncgmgnk _1v9m6rms _olwp9cwz _1cxzq7pw _19iy12c5 _tf7r13g8 _6fdwp3kn _9sps1o8l _o6dk1osq _1yd81ylp _7vnk1ylp _1wpyusvi _v2ut1q9c _l5tc1l2s _1c279jpi _1t5x1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Tokenized = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { draggableState: draggableState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko12b0 _80om73ad _kqswh2mm _c71l1ylp _1bfhidpf _ncow1dpa _t6db1j28 _1uyw1dpa _7k461aqn _5hvf1rpy _1kzckb7n _n5sikb7n _1j6mf1ug _9vpt1osq _1vjv1txw _1dsjidpf _hpfx19bv _1pi6idpf _1rqg19bv _j8ve1gyu _d8gsu2gc _1m7d1ylp _nfqw1h6o _mig07vkz _rqui7vkz _1mfy7vkz _1tlu7vkz _1uzz7vkz _1nao7vkz _1knu7vkz _1m537vkz _18387vkz _5fr87vkz _1x8p7vkz _3uc87vkz _dgj27vkz _f2tv7vkz _ors87vkz _19q77vkz _drvf7vkz _dz5k7vkz _1xdi7vkz _1mjq7vkz _1ozr7vkz _p4o77vkz _b4047vkz _1hlo7vkz _1f4k7vkz _1c2c7vkz _6ghj7vkz _wc727vkz _ppk67vkz _12it7vkz _1p521txw _1n2o1txw _1v241txw _1o8v1txw _t8q21txw _y3u81h6o _3zzm1h6o _aird1h6o _rcsr1h6o _19fb1h6o _1wjbi7uo _109o1ylp _1c877vkz _1so97vkz _1s5b7vkz _1uhy7vkz _1bti7vkz _10zm7vkz _16nc7vkz _1ilt7vkz _1t827vkz _rcgi7vkz _uyp97vkz _cbv57vkz _142w7vkz _1fe57vkz _1cld7vkz _3h3j7vkz _1emvnkob _1lbdnkob _az5onkob _w68onkob _109o14no _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43dsazsu _p03cazsu _oavvazsu _oxk4azsu _1cayazsu _13uifcek _j0cz1osq _jdednpx7 _15kb6x5g _13ozidpf _1nypidpf _yuv7idpf _hrieidpf _13wbidpf _aliv1tcg _p1061tcg _13i61tcg _1cayd34b _irr31dpa",
            __cmplp.draggableState === 'dragging' ? "_tzy41ck0" : "_tzy4kb7n",
            __cmplp.draggableState === 'idle' ? "_jomr1dpa _10j71dpa _irr31dpa" : "_jomr1wug _10j71wug _irr31wug",
            __cmplp.draggableState === 'idle' ? "_1y9g1kr1 _1rhokb7n" : "_1rhoidpf",
            !$8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() && "_cs4c15vq _lgpm15vq _jt20idpf _1vm1or1b _1xsaidpf _1l4e1crf _1p7a1r31 _hg20glyw _1lv6nqa1 _nn7ofhey _19y2178v _t41dlb4i _11r2b3bt _hy7n1o8l _i2xg14yf _1som14yf _wvd5h2mm _1jz6i2wt _avkbidpf _1h687vkz _1086glyw _19i6f0ml _fncgmgnk _1v9m6rms _olwp9cwz _1cxzq7pw _19iy12c5 _tf7r13g8 _6fdwp3kn _9sps1o8l _o6dk1osq _1yd81ylp _7vnk1ylp _1wpyusvi _v2ut1q9c _l5tc1l2s _1c279jpi _1t5x1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Wrapper for feature-flagged styled container (go/DSP-18766)
const $8bcdd2b9838a59f9$export$c318e931097be377 = (props)=>{
    const Component = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Tokenized : $8bcdd2b9838a59f9$var$ShortcutsItemContainerNav3Legacy;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
};
const $8bcdd2b9838a59f9$var$itemStyles = {
    base: "_2rkofajl _kqswh2mm _4t3izwfg _19pkidpf _fj131y44 _k1o11y44 _1rgb1y44 _mto2ftgi _1h2b18uv _ekv6fhey _1ufy15vq _turg15vq _1lb9idpf _43dsd34b _bpsp1wq8 _hstc1u1b _9r1zxy5q _1hw71ule _2cf31l2s _sjfo1q9c _f8z6idpf _qzhyidpf _1m2nidpf _15kaidpf _1jkvu2gc _jzj9cj1k _4pm24jg8 _plbeidpf _1xqcplhp _vw87f705 _1wg6stnw _j8vb19bv _1o2dyh40 _1aum1crf _11nm1tcg _y0rh1wug _36ko1r8n _13hu1q5k _14hp1tcg _jq8g1tcg _dpd31txw _xlob1h6o _12no1h6o _jmnr1j28 _13hbd34b _k6cg1crf _1d421crf _rfqo1r31 _1bgkglyw _1t0pnqa1 _3ifa1dpa _irr31dpa",
    dragging: "_tzy41ck0",
    isMenuOpen: "_1kx4fcek"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bcdd2b9838a59f9$var$PopupTrigger = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1aaxusic _p12fidpf _c71lidpf _3um015vq",
            __cmplp.className
        ])
    });
});
const $8bcdd2b9838a59f9$var$i18n = (0, $aXWIB.defineMessages)({
    shortcutsQuickActionsRemoveButton: {
        id: "space-shortcuts.shortcuts.quick-actions.remove",
        defaultMessage: "Remove"
    },
    draggableItemLabel: {
        id: "space-shortcuts.draggable-item.label",
        defaultMessage: "{title} draggable item"
    }
});
const $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE = 'shortcuts-item'; // string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const $8bcdd2b9838a59f9$var$relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i'); // adding domain to relative confluence URLs so smart links don't error
const $8bcdd2b9838a59f9$export$2414511207262909 = (url, isExternal)=>{
    if (url === null) return url;
    if (!isExternal && $8bcdd2b9838a59f9$var$relativeUrlMatch.test(url)) return window.location.origin + url;
     // edge case that doesn't match regexp
    if (url.match(`${window.location.protocol}///wiki`)) return window.location.origin + url.replace(`${window.location.protocol}//`, '');
    return url;
};
const $8bcdd2b9838a59f9$export$69a9b8d15b4aa378 = ({ flags: flags, item: item, index: index, spaceId: spaceId, createAnalyticsEvent: createAnalyticsEvent, isSpaceAdmin: isSpaceAdmin, links: links, deleteShortcut: deleteShortcut, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
    const ref = (0, $42omo.useRef)(null);
    const refPreview = (0, $42omo.useRef)(null);
    const intl = (0, $aXWIB.useIntl)();
    const CardComponent = $8bcdd2b9838a59f9$export$a8c2f05884e8c7a1() ? (0, $9CM6e.CardSSR) : (0, $hpUsb.Card);
    let { url: url, styleClass: styleClass } = item;
    url = url || '';
    const { title: title = '', id: id } = item; //styleClass is the old way of knowing if a link was internal or external
    styleClass = styleClass || '';
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let target = '_blank', navdexPointType = null;
    try {
        const isRelativeUrl = matchRoute(url);
        const includesHostName = url.includes(window.location.hostname);
        const containsExternalStyleClass = styleClass.indexOf('external_link') >= 0; //now we also check if the link is relative or contains the pathname, falls back to styleclass
        const isExternal = !(isRelativeUrl || includesHostName) && containsExternalStyleClass;
        url = $8bcdd2b9838a59f9$export$2414511207262909(url, isExternal) || '';
        target = isExternal ? '_blank' : '_self';
        navdexPointType = !isExternal ? (0, $56QzY.START_TOUCH) : null;
    } catch  {
        // eslint-disable-next-line no-console
        console.warn('malformed URL:', url); //prefer to show a different UI when the link is bad, letting the user know they should update the shortcut...
    //however the smartcard format doesn't really have a way to do this.
    }
    const [isEditOpen, setIsEditOpen] = (0, $42omo.useState)(false);
    const [isActionMenuOpen, setIsActionMenuOpen] = (0, $42omo.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $42omo.useState)(null);
    const [draggableState, setDraggableState] = (0, $42omo.useState)('idle');
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsEditOpen(false);
    }, [
        setIsEditOpen
    ]);
    const openEdit = (0, $42omo.useCallback)(()=>{
        setIsEditOpen(!isEditOpen);
    }, [
        isEditOpen,
        setIsEditOpen
    ]);
    const handleSubmit = (0, $h4oCC.useEditShortcut)(links, flags, spaceId);
    const onSubmit = (0, $42omo.useCallback)((href, displayText)=>{
        handleSubmit({
            id: id,
            url: href,
            title: displayText || ''
        });
        handleClose();
    }, [
        handleClose,
        handleSubmit,
        id
    ]);
    const location = 'confluenceShortcuts';
    const sendShortcutClickedAnalytics = (navdexPointType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'spaceShortcut',
                    source: 'containerNavigation',
                    containerType: 'space',
                    containerId: spaceId,
                    attributes: {
                        navVersion: '3',
                        ...navdexPointType && {
                            navdexPointType: navdexPointType
                        },
                        location: location
                    }
                }
            }).fire();
        };
    (0, $42omo.useEffect)(()=>{
        if (!isSpaceAdmin && (0, $6mKj3.expVal)('confluence_frontend_js_reduction-shortcuts', 'isEnabled', false)) return;
        (0, $dRnqM.default)(ref.current);
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: ref.current,
            onGenerateDragPreview: ({ source: source, nativeSetDragImage: nativeSetDragImage })=>{
                (0, $4AppU.scrollJustEnoughIntoView)({
                    element: source.element
                });
                (0, $afUmf.setCustomNativeDragPreview)({
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render: ({ container: container })=>{
                        // eslint-disable-next-line react/no-deprecated
                        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bcdd2b9838a59f9$var$DragPreview, {
                            ref: refPreview
                        }), container);
                        if (refPreview.current) refPreview.current.innerHTML = ref.current?.innerHTML ?? '';
                         // eslint-disable-next-line react/no-deprecated
                        return ()=>(0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(container);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                setDraggableState('dragging');
                onDragStart && onDragStart();
            },
            getInitialData: ()=>({
                    id: item.id,
                    type: $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE
                }),
            // attach a url for other documents and applications
            getInitialDataForExternal: ()=>{
                if (!url) return {};
                return {
                    'text/uri-list': url
                };
            },
            onDrop: ()=>{
                setDraggableState('idle');
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: ref.current,
            canDrop: ({ source: source })=>{
                return source.data.type === $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE;
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.id,
                    type: $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE,
                    index: index
                };
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag: ({ self: self, source: source, location: location })=>{
                if (source.data.id !== item.id && location?.current?.dropTargets[0]?.data?.id === item.id) setClosestEdge((0, $2WHHL.extractClosestEdge)(self.data));
                else setClosestEdge(null);
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ({ location: location })=>{
                if (location?.current?.dropTargets[0]) {
                    const { data: target } = location.current.dropTargets[0];
                    const { data: source } = location.initial.dropTargets[0];
                    const edge = (0, $2WHHL.extractClosestEdge)(target);
                    if (!target || !target.id || target.type !== $8bcdd2b9838a59f9$var$SHORTCUTS_ITEM_TYPE || target.id === item.id && !edge) return;
                    const sourcePosition = {
                        index: source.index
                    };
                    const destinationPosition = {
                        index: (0, $7XdU2.getReorderDestinationIndex)({
                            startIndex: source.index,
                            indexOfTarget: target.index,
                            closestEdgeOfTarget: edge,
                            axis: 'vertical'
                        })
                    };
                    if (sourcePosition.index !== destinationPosition.index) onDragEnd(sourcePosition, destinationPosition);
                }
                setClosestEdge(null);
            }
        }));
    }, [
        isSpaceAdmin,
        onDragStart,
        onDragEnd,
        item,
        index,
        url
    ]);
    const disableNativeDragOnLinks = ()=>{
        if (!ref.current) return;
        Array.from(ref.current.querySelectorAll('a')).forEach((anchor)=>anchor.setAttribute('draggable', 'false'));
    };
    const handleComplete = ()=>{
        disableNativeDragOnLinks();
    };
    const handleCompleteError = ()=>{
        disableNativeDragOnLinks();
    };
    const hash = (0, $1AV5C.hashData)(`${title}-${url}`);
    const placeholderId = `shortcut-item-${index}-${hash}`;
    const itemContent = // TODO: Add `shouldRenderToParent={true}` to meet a11y requirements. See
    // https://a11y.atlassian.net/browse/JCATS-788
    // https://hello.jira.atlassian.cloud/browse/DISCO-4293
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CardComponent, {
        testId: "shortcut-item",
        appearance: "inline",
        url: url || '',
        placeholder: title || undefined,
        onClick: sendShortcutClickedAnalytics(navdexPointType),
        onResolve: handleComplete,
        onError: handleCompleteError,
        ui: {
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            clickableContainer: true,
            size: (0, $5TXU5.SmartLinkSize).Medium
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        text: title || undefined,
        anchorTarget: target,
        hideTitleTooltip: true,
        actions: isSpaceAdmin ? [
            {
                name: (0, $5TXU5.ActionName).EditAction,
                onClick: openEdit,
                iconPosition: 'before',
                testId: 'editAction'
            },
            {
                name: (0, $5TXU5.ActionName).DeleteAction,
                onClick: ()=>deleteShortcut(item),
                iconPosition: 'before',
                testId: 'deleteAction',
                content: intl.formatMessage($8bcdd2b9838a59f9$var$i18n.shortcutsQuickActionsRemoveButton)
            }
        ] : undefined,
        showActionOnHover: true,
        onActionMenuOpenChange: ({ isOpen: isOpen })=>{
            setIsActionMenuOpen(isOpen);
        },
        placeholderId: placeholderId
    })), (isEditOpen || isActionMenuOpen || !(0, $6mKj3.expVal)('confluence_frontend_js_reduction-shortcuts', 'isEnabled', false)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        isOpen: isEditOpen,
        onClose: ()=>handleClose(),
        content: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bcdd2b9838a59f9$var$LinkPickerWithPlugin, {
                ...props,
                onSubmit: ({ url: url, displayText: displayText })=>{
                    onSubmit(url, displayText);
                },
                onCancel: handleClose,
                url: url || '',
                displayText: title || ''
            })),
        placement: "bottom-start",
        offset: [
            -42,
            4
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8bcdd2b9838a59f9$var$PopupTrigger, triggerProps)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
        testId: "space-shortcuts-actions-blanket",
        isTinted: false,
        shouldAllowClickThrough: !isEditOpen && !isActionMenuOpen,
        onBlanketClicked: ()=>{
            setIsActionMenuOpen(false);
            setIsEditOpen(false);
        }
    })), closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2n8po.DropIndicator), {
        edge: closestEdge
    }) : null);
    const isMenuOpen = isActionMenuOpen || isEditOpen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "li",
        ref: ref,
        "aria-label": intl.formatMessage($8bcdd2b9838a59f9$var$i18n.draggableItemLabel, {
            title: title
        }),
        xcss: (0, $1Whri.cx)($8bcdd2b9838a59f9$var$itemStyles.base, $8bcdd2b9838a59f9$var$itemStyles[draggableState], isMenuOpen && $8bcdd2b9838a59f9$var$itemStyles.isMenuOpen)
    }, itemContent);
};
const $8bcdd2b9838a59f9$export$a115102ddf435124 = (0, $7aRa9.withFlags)($8bcdd2b9838a59f9$export$69a9b8d15b4aa378);





// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42c81fda1a12071e$var$ShortcutsListContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
});
const $42c81fda1a12071e$var$ShortcutsDragContainerComponent = /*#__PURE__*/ (0, $42omo.memo)(({ flags: flags, isSpaceAdmin: isSpaceAdmin, links: links, spaceId: spaceId, spaceKey: spaceKey, shortcutsHistoryRef: shortcutsHistoryRef })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { moveShortcut: moveShortcut, undoMoveShortcut: undoMoveShortcut } = (0, $h4oCC.useMoveShortcut)(links, flags, shortcutsHistoryRef);
    const { deleteShortcut: deleteShortcut, undoDeleteShortcut: undoDeleteShortcut } = (0, $h4oCC.useDeleteShortcut)(links, flags, shortcutsHistoryRef);
    const hideLastUndoFlag = ()=>{
        // hides previous success flag so that only one is on the screen at a time
        const lastMovement = shortcutsHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
    };
    const onDeleteShortcut = (item)=>{
        hideLastUndoFlag();
        deleteShortcut(item);
        shortcutsHistoryRef.current.push({
            undo: ()=>undoDeleteShortcut(item),
            // makes the confirmation flag display the message reflecting only the latest change
            lastDeletedItem: item
        });
    };
    const onDragStart = async ()=>{
        // hides the success flag when moving a subsequent shortcut
        hideLastUndoFlag();
    };
    const onDragEnd = async (source, destination)=>{
        hideLastUndoFlag();
        moveShortcut(source, destination);
        shortcutsHistoryRef.current.push({
            undo: ()=>{
                undoMoveShortcut(source);
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'undo',
                        actionSubject: 'update',
                        actionSubjectId: 'spaceShortcuts',
                        source: 'viewPageScreen',
                        attributes: {
                            previousRank: source,
                            newRank: destination,
                            action: 'reorder'
                        }
                    }
                }).fire();
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'updated',
                actionSubject: 'spaceShortcuts',
                source: 'viewPageScreen',
                attributes: {
                    previousRank: source,
                    newRank: destination,
                    action: 'reorder'
                }
            }
        }).fire();
    };
    const displayLinks = (0, $42omo.useMemo)(()=>Array.from(links).reverse(), [
        links
    ]);
    const pageIds = displayLinks.filter((item)=>(item.styleClass || '').indexOf('external_link') < 0).filter((item)=>(0, $1NBp8.VIEW_PAGE).match(item.url || '')).map((item)=>(0, $1NBp8.VIEW_PAGE).match(item.url || '')?.params.contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($42c81fda1a12071e$var$ShortcutsListContainer, {
        "data-vc": "shortcuts-drag-container",
        ...ssrPlaceholderIdProp
    }, displayLinks.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bcdd2b9838a59f9$export$a115102ddf435124), {
            key: `shortcuts-item-${item?.id || index}`,
            item: item,
            index: index,
            spaceId: spaceId,
            createAnalyticsEvent: createAnalyticsEvent,
            isSpaceAdmin: isSpaceAdmin,
            links: links,
            deleteShortcut: onDeleteShortcut,
            onDragStart: onDragStart,
            onDragEnd: onDragEnd
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8b3b36815423b52$export$8a2496cd6c012f98), {
        id: spaceKey,
        action: "initialized",
        actionSubject: "spaceShortcutsSection",
        source: "dashboard",
        containerType: "space",
        containerId: spaceId,
        attributes: {
            navVersion: '3',
            numOfShortcuts: links.length,
            pageIds: pageIds
        },
        createAnalyticsEvent: createAnalyticsEvent
    }));
});
const $42c81fda1a12071e$export$e03e20755e26b5e9 = (0, $7aRa9.withFlags)($42c81fda1a12071e$var$ShortcutsDragContainerComponent);
module.exports["ShortcutsDragContainer"] = $42c81fda1a12071e$export$e03e20755e26b5e9;

});

parcelRegister("7XdU2", function(module, exports) {
function $68bcb6b8502e57f3$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}
module.exports["getReorderDestinationIndex"] = $68bcb6b8502e57f3$export$846f792f51b92b6e;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("32LtO", function(module, exports) {

let $237663816f901b3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $237663816f901b3c$var$load("b90ZR"),
    $237663816f901b3c$var$load("kbwlB"),
    $237663816f901b3c$var$load("j5D98"),
    $237663816f901b3c$var$load("2YffH"),
    $237663816f901b3c$var$load("eBRUf"),
    $237663816f901b3c$var$load("bGpE6"),
    $237663816f901b3c$var$load("hUmZG"),
    $237663816f901b3c$var$load("4RbVd"),
    $237663816f901b3c$var$load("9ldRJ"),
    $237663816f901b3c$var$load("9wzNh"),
    $237663816f901b3c$var$load("3MYQs"),
    $237663816f901b3c$var$load("6SWFK"),
    $237663816f901b3c$var$load("5zapo"),
    $237663816f901b3c$var$load("jiFtb"),
    $237663816f901b3c$var$load("6wr18"),
    $237663816f901b3c$var$load("ffEVr"),
    $237663816f901b3c$var$load("9atVd"),
    $237663816f901b3c$var$load("dek7I"),
    $237663816f901b3c$var$load("fFddv")
]).then(()=>parcelRequire('7Wd2W'));

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("4JDbp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("bIwjt", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");


var $gmi3X = parcelRequire("gmi3X");

const $852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE = 'smart-card-social-proof';
const $852fcfb8b079dfa1$export$f44b87513fae83d9 = 'site-cloud-id:v1:';
const $852fcfb8b079dfa1$export$a99d139543208cca = 86400000;
const $852fcfb8b079dfa1$var$smartCardStorage = new (0, $kt8c2.default)($852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE);
function $852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
function $852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash = '') {
    return `${$852fcfb8b079dfa1$export$f44b87513fae83d9}${encodeURIComponent($852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash))}`;
}
const $852fcfb8b079dfa1$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${$852fcfb8b079dfa1$var$SMART_CARD_STORAGE_SCOPE}_${$852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash)}`;
const $852fcfb8b079dfa1$export$b4b75b5ce5d33ae5 = $852fcfb8b079dfa1$export$dea1a8bc5840f118();
class $852fcfb8b079dfa1$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $852fcfb8b079dfa1$var$smartCardStorage.getItem($852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $852fcfb8b079dfa1$var$smartCardStorage.setItemWithExpiry($852fcfb8b079dfa1$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash), cloudId, $852fcfb8b079dfa1$export$a99d139543208cca);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = $852fcfb8b079dfa1$var$normalizeBaseUri(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $gmi3X.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
const $852fcfb8b079dfa1$export$1956112846aa829e = new $852fcfb8b079dfa1$export$a15da722a3b05509();
function $852fcfb8b079dfa1$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return $852fcfb8b079dfa1$export$1956112846aa829e.getStoredCloudId(baseUriWithNoTrailingSlash);
}
const $852fcfb8b079dfa1$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>$852fcfb8b079dfa1$export$1956112846aa829e.get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudIdSync"] = $852fcfb8b079dfa1$export$763646cf0dfa675c;
module.exports["getCurrentSiteCloudId"] = $852fcfb8b079dfa1$export$143af22820ae9de;

});

parcelRegister("iWvOt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Y0OXK = parcelRequire("Y0OXK");


var $hL5V3 = parcelRequire("hL5V3");

const $f9f9ad585f1b3a08$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $hL5V3.useConfluencePageData)(props.src || '', extensionKey || '');
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Y0OXK.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $f9f9ad585f1b3a08$export$b32b5f1ee4493319;

});

parcelRegister("Y0OXK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $eNWGp = parcelRequire("eNWGp");

const $7e20740578e340e4$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eNWGp.Page), props));
module.exports["Page"] = $7e20740578e340e4$export$6955bcca4cd3539f;

});

parcelRegister("a4Weo", function(module, exports) {

var $504sF = parcelRequire("504sF");


var $5GGZL = parcelRequire("5GGZL");

const $eae070da32ac21dd$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $504sF.default;
        case 'en-US':
        default:
            return 0, $5GGZL.default;
    }
};
var $eae070da32ac21dd$export$2e2bcd8739ae039 = $eae070da32ac21dd$var$fetchTranslations;
module.exports["default"] = $eae070da32ac21dd$export$2e2bcd8739ae039;

});

parcelRegister("504sF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e428a1b86b9241f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $0e428a1b86b9241f$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("5GGZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $45dca5869897ff09$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $45dca5869897ff09$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("eNWGp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7k8Uw = parcelRequire("7k8Uw");


var $aXWIB = parcelRequire("aXWIB");


var $6uh00 = parcelRequire("6uh00");


var $5qNp3 = parcelRequire("5qNp3");

const $172be5db228fd17c$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uh00.ViewPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5qNp3.EditPage), {
        locale: locale,
        ...props
    });
};
const $172be5db228fd17c$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7k8Uw.Page), {
        locale: locale,
        ...props,
        viewComponent: $172be5db228fd17c$var$ViewComponent,
        editComponent: $172be5db228fd17c$var$EditComponent
    });
};
module.exports["Page"] = $172be5db228fd17c$export$6955bcca4cd3539f;

});

parcelRegister("6uh00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $ktyYp = parcelRequire("ktyYp");

const $6d62a53500c7e32b$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ktyYp.ViewPage), props));
module.exports["ViewPage"] = $6d62a53500c7e32b$export$767e3006bdbb424a;

});

parcelRegister("ktyYp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aI44c = parcelRequire("aI44c");


var $aXWIB = parcelRequire("aXWIB");

const $216b1f3eb7fd7629$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aI44c.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $216b1f3eb7fd7629$export$767e3006bdbb424a;

});

parcelRegister("5qNp3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $I1nNR = parcelRequire("I1nNR");


var $a4Weo = parcelRequire("a4Weo");


var $657oH = parcelRequire("657oH");

const $8690a9fa0f1ae334$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $a4Weo.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $657oH.EditPage), props));
module.exports["EditPage"] = $8690a9fa0f1ae334$export$1fea75498367c4ac;

});

parcelRegister("657oH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aiCKw = parcelRequire("aiCKw");


var $aXWIB = parcelRequire("aXWIB");

const $015976cb7cb7475e$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aiCKw.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $015976cb7cb7475e$export$1fea75498367c4ac;

});

parcelRegister("hL5V3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bRSdj = parcelRequire("bRSdj");

var $lw2XG = parcelRequire("lw2XG");

var $7e0969c4e751a56a$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $7e0969c4e751a56a$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $7e0969c4e751a56a$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $7e0969c4e751a56a$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $42omo.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($7e0969c4e751a56a$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $lw2XG.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $42omo.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $bRSdj.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $7e0969c4e751a56a$export$10fb2803bc7b79fc;

});

parcelRegister("4vCA9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a879f42abb981ca6$var$placeholderShimmer = null;
const $a879f42abb981ca6$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $a879f42abb981ca6$var$spanSkeletonStyles = null;
const $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $a879f42abb981ca6$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $a879f42abb981ca6$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $gMc0m.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $a879f42abb981ca6$export$2e2bcd8739ae039 = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $a879f42abb981ca6$export$85d5658002cae6ce;
module.exports["Skeleton"] = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;

});


//# sourceMappingURL=ShortcutsDragContainer.5a93ceda.js.map
